<template>
  <div class="mark">
    <img src="/imgs/user/centerbg.png" alt="" class="centerpng" />
    <div class="perfectInformation">
      <div class="left_banner"></div>
      <div class="right_content">
        <div class="title">
          为了更好的为您服务<br />
          请完善以下信息，确认信息后不可更改
        </div>
        <!-- 所在地 -->
        <div class="linkage" v-if="openProvinceData.length == 0">
          <div class="zheceng" v-if="tuance"></div>
          <p class="no1" style="width: 80px">地区：</p>
          <div class="el">
            <el-select
              v-model="province"
              placeholder="省级地区"
              class="suozaidi1"
            >
              <el-option
                v-for="(item, index) in mapData"
                :key="index"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
          <p class="no2">省/市</p>
          <div class="el">
            <el-select v-model="city" placeholder="市级地区" class="suozaidi2">
              <el-option
                v-for="(item, index) in cityData"
                :key="index"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
          <p class="no2">城市</p>
          <div class="el">
            <el-select v-model="area" placeholder="区级地区" class="suozaidi3">
              <el-option
                v-for="(item, index) in areaData"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <p class="no2">区/县/市</p>
        </div>

        <div class="linkage" v-if="openProvinceData.length > 0">
          <div class="zheceng" v-if="tuance"></div>
          <p class="no1" style="width: 80px">地区：</p>
          <div class="el">
            <el-select
              v-model="province"
              placeholder="省级地区"
              class="suozaidi1"
            >
              <el-option
                v-for="(item, index) in openProvinceData"
                :key="index"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
          <p class="no2">省/市</p>
          <div class="el">
            <el-select
              v-model="city"
              placeholder="市级地区"
              class="suozaidi2"
              @change="currentSel"
            >
              <el-option
                v-for="(item, index) in openCityData"
                :key="index"
                :label="item.name"
                :value="item.name"
                @change="currentSel"
              >
              </el-option>
            </el-select>
          </div>
          <p class="no2">城市</p>
          <div class="el" v-show="isSelectShow">
            <el-select v-model="area" placeholder="区级地区" class="suozaidi3">
              <el-option
                v-for="(item, index) in areaData"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div class="el" v-show="isSelectShow2">
            <el-select
              v-model="area"
              placeholder="区级地区"
              @change="currentSel2"
              class="suozaidi3"
            >
              <el-option
                v-for="item in areaData2"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </div>
          <div class="el" v-show="isSelectShow3">
            <el-select
              v-model="area"
              placeholder="区级地区"
              @change="currentSel2"
              class="suozaidi3"
            >
              <el-option
                v-for="item in areaData3"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </div>
          <div class="el" v-show="isSelectShow4">
            <el-select
              v-model="area"
              placeholder="区级地区"
              @change="currentSel2"
              class="suozaidi3"
            >
              <el-option
                v-for="item in areaData4"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </div>
          <p class="no2">区/县/市</p>
        </div>
        <!-- 学校 -->
        <div class="xuexiao" :style="{ marginBottom: tuance && '25px' }">
          <div class="zheceng" v-if="tuance"></div>
          <p class="no1" style="width: 80px">学校：</p>
          <input
            type="text"
            v-model="school"
            placeholder="请输入学校的名称"
            onfocus="placeholder=''"
            onblur="placeholder='请输入学校的名称'"
          />
        </div>
        <!-- 高考年份 -->
        <div class="year" :style="{ marginBottom: tuance && '25px' }">
          <div class="zheceng" v-if="tuance"></div>
          <p class="no1" style="width: 80px">高考年份：</p>
          <el-select
            v-model="year"
            class="year1"
            slot="prepend"
            placeholder="请选择"
          >
            <el-option
              :label="years + item - 1"
              :value="years + item - 1"
              v-for="(item, index) in 6"
              :key="index"
            ></el-option>
            <el-option label="成年人" value="成年人"></el-option>
          </el-select>
          &nbsp;<span>{{ nianji[year - years] }}</span>
          <!--                         <span class="no2">当前选择年份适用高三学生</span>-->
        </div>
        <!-- 班级 -->
        <div
          class="ownname"
          v-if="tuance"
          :style="{ marginBottom: tuance && '25px' }"
        >
          <p class="no1" style="width: 80px">班级：</p>
          <el-select
            v-model="classNumber"
            class="classNumber"
            slot="prepend"
            placeholder="请选择"
          >
            <el-option
              :label="start + item - 1"
              :value="start + item - 1"
              v-for="item in end - start + 1"
              :key="index"
            ></el-option>
          </el-select>
        </div>
        <!-- 姓名 -->
        <div class="ownname" :style="{ marginBottom: tuance && '25px' }">
          <p class="no1" style="width: 80px">姓名：</p>
          <input
            type="text"
            v-model="ownname"
            placeholder="请输入你的姓名"
            onfocus="placeholder=''"
            onblur="placeholder='请输入你的姓名'"
          />
        </div>
        <!-- 请输入手机号-->
        <div
          class="ownname"
          v-if="tuance"
          :style="{ marginBottom: tuance && '25px' }"
        >
          <p class="no1" style="width: 80px">手机：</p>
          <input
            type="number"
            v-model="phone"
            placeholder="请输入你的手机号"
            onfocus="placeholder=''"
            onblur="placeholder='请输入你的手机号'"
          />
        </div>
        <div class="userTab">
          <p class="no1" style="width: 80px">性别：</p>
          <div
            class="item"
            :style="{ backgroundImage: 'url(' + manBlue + ')' }"
            v-if="sex == 1"
          >
            <span style="color: #fff">男</span>
          </div>
          <div
            class="item"
            :style="{ backgroundImage: 'url(' + womanWhite + ')' }"
            v-if="sex == 1"
            @click="sex = 2"
          >
            <span style="color: #3d90f6">女</span>
          </div>
          <div
            class="item"
            :style="{ backgroundImage: 'url(' + manWhite + ')' }"
            v-if="sex == 2"
            @click="sex = 1"
          >
            <span style="color: #3d90f6">男</span>
          </div>
          <div
            class="item"
            :style="{ backgroundImage: 'url(' + womanBlue + ')' }"
            v-if="sex == 2"
          >
            <span style="color: #fff">女</span>
          </div>
        </div>
        <!--                    <div class="sex">-->
        <!--                        <div class="el">-->
        <!--                            <el-radio-group v-model="sex">-->
        <!--                                <el-radio :label="1">男</el-radio>-->
        <!--                                <el-radio :label="2" class="women">女</el-radio>-->
        <!--                            </el-radio-group>-->
        <!--                        </div>-->
        <!--                    </div>-->

        <p class="warning">{{ warning }}</p>
        <div @click="goHome" class="goHome">确定</div>
        <!-- <p class="bottom">注以上信息一旦提交不能修改</p> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // props: [ 'message' ],
  data() {
    return {
      // 接收省市区数据
      mapData: [],
      // // 省份数据
      // provinceData: [],
      // 市、县数据
      cityData: [],
      // 区数据
      areaData: [],
      areaData2: [
        {
          value: "1",
          label: "肇源县",
        },
      ],
      areaData3: [
        {
          value: "1",
          label: "北林区",
        },
      ],
      areaData4: [
        { value: "1", label: "龙沙区" },
        { value: "2", label: "建华区" },
        { value: "3", label: "铁锋区" },
        { value: "4", label: "富拉尔基区" },
        { value: "5", label: "昂昂溪区" },
        { value: "6", label: "碾子山区" },
        { value: "7", label: "梅里斯达斡尔族区" },
      ],
      // 省市区
      province: "",
      city: "",
      area: "",
      school: "",
      year: "",
      ownname: "",
      sex: 1,
      // 错误提示
      warning: "",
      //班级
      classNumber: "",
      phone: "",
      // agentId为20时，是学马自己的不限制省份，其他为代理商，限制省份
      agentId: -1,
      province0: "",
      city0: "",
      area0: "",
      school0: "",
      year0: "",
      // 代理商开通省市
      openProvinceData: [],
      openCityData: [],
      isShowScoll: false,
      tuance: false,
      start: "",
      end: "",
      years: "",
      nianji: ["高三", "高二", "高一", "初三", "初二", "初一"],
      manBlue: "/imgs/user/nan_lan.png",
      manWhite: "/imgs/user/nan_bai.png",
      womanBlue: "/imgs/user/nv_lan.png",
      womanWhite: "/imgs/user/nv_bai.png",
      OEMdomain: "",
      isSelectShow: true,
      isSelectShow2: false,
      isSelectShow3: false,
      isSelectShow4: false,
      setVal: "",
      setVal2: "",
    };
  },
  watch: {
    province() {
      // 如果代理商设置了省
      var provinceName = this.province;
      var _this = this;
      this.warning = "";
      if (this.province0) {
        this.province = this.province0;
      } else {
        this.city = "";
      }
      if (this.openProvinceData.length == 0) {
        this.mapData.forEach(function (item, index) {
          if (item.name == provinceName) {
            _this.cityData = item.cityList;
            // return;
          }
        });
      } else {
        this.openProvinceData.forEach(function (item, index) {
          if (item.name == provinceName) {
            _this.openCityData = item.child;
          }
        });
      }
    },
    city() {
      var provinceName = this.province;
      var cityName = this.city;
      var _this = this;
      var arr1 = [];
      var arr2 = [];
      this.warning = "";
      if (this.city0) {
        this.city = this.city0;
      } else {
        this.area = "";
      }
      if (this.openProvinceData.length == 0) {
        this.cityData.forEach(function (item, index) {
          if (item.name == cityName) {
            // console.log(555555)
            _this.areaData = item.areaList;
            return;
          }
        });
      } else {
        this.mapData.forEach(function (item, index) {
          if (item.name == provinceName) {
            arr1 = item.cityList;
            return;
          }
        });
        arr1.forEach(function (item, index) {
          if (item.name == cityName) {
            _this.areaData = item.areaList;
            return;
          }
        });
      }
    },
    area() {
      this.warning = "";
      if (this.area0) {
        this.area = this.area0;
      }
    },
    school() {
      this.warning = "";
      if (this.school0) {
        this.school = this.school0;
      }
    },
    year() {
      if (this.year0) {
        this.year = this.year0;
      }
    },
    ownname() {
      this.warning = "";
    },
  },
  methods: {
    currentSel(setVal){
      this.setVal = setVal
      if(this.OEMdomain == 'zyl.xuematech.com' && this.setVal == '大庆市'){    
      this.isSelectShow2=true,
      this.isSelectShow=false,
      this.isSelectShow3=false,
      this.isSelectShow4=false
	}
    else if(this.OEMdomain == 'zyl.xuematech.com' && this.setVal == '绥化市'){	
      this.isSelectShow3=true,
      this.isSelectShow=false,
      this.isSelectShow2=false,
      this.isSelectShow4=false
    }
    else if(this.OEMdomain == 'zyl.xuematech.com' && this.setVal == '齐齐哈尔市'){
      this.isSelectShow4=true,
      this.isSelectShow=false,
      this.isSelectShow2=false,
      this.isSelectShow3=false
    }
    else{
      this.isSelectShow=true,
      this.isSelectShow2=false,
      this.isSelectShow3=false,
      this.isSelectShow4=false
    }
	},
	currentSel2(val){
	  this.school = val
	},
    // 加载china地点数据，三级
    getCityData: function () {
      var _this = this;
      this.$ajax
        .get("/data/map.json")
        .then(function (res) {
          if (res.status == 200) {
            _this.mapData = res.data;
          }
        })
        .then(function (res) {
          _this.getUserInfo();
        })
        .catch(function (error) {});
    },
    goHome() {
      this.warning = "";
      if (!this.province) {
        this.warning = "请选择省份";
        return;
      }
      if (!this.city) {
        this.warning = "请选择城市";
        return;
      }
      if (!this.area) {
        this.warning = "请选择区/县/市";
        return;
      }

      if (!this.school) {
        this.warning = "请填写学校名称";
        return;
      }
      if (this.tuance) {
        if (!this.classNumber) {
          this.warning = "请填写班级";
          return;
        }
      }
      if (!this.ownname) {
        this.warning = "请填写姓名";
        return;
      }
      if (this.tuance) {
        if (!this.phone) {
          this.warning = "请填写手机号";
          return;
        }
        var reg = /(^1[123456789]\d{9}$)|(^\d{8}$)/;
        if (!reg.test(this.phone)) {
          this.warning = "请输入正确的手机号";
          return;
        }
      }
      if (!this.sex) {
        this.warning = "请选择性别";
        return;
      }
      var province = this.province;
      var city = this.city;
      var area = this.area;
      var schoolName = this.school;
      var baccllYear = this.year;
      var name = this.ownname;
      var sex = this.sex;
      var token = window.sessionStorage.getItem("ymtxToken");
      var _this = this;
      var schoolClass = this.classNumber;
      var phone = this.phone;
      this.$ajax
        // get请求
        .post(
          this.G_uri + this.ports.user.setImproveInfo,
          {
            // data
            province: province,
            city: city,
            area: area,
            schoolName: schoolName,
            baccllYear: baccllYear,
            name: name,
            sex: sex,
            token: token,
            schoolClass: schoolClass,
            phone: phone,
          },
          {
            headers: {
              token: token,
            },
          }
        )
        // 监听数据返回
        .then(function (res) {
          if (res.data.code == 2000 && res.data.data.id > 0) {
            _this.$router.push("/careerArchives");
          }else if(res.data.code == 2000 && res.data.data.id <= 0){
            _this.$router.push("/login");
          }else{
            _this.warning = res.data.msg
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // 获取代理商代理省份城市
    getProvance() {
      // agent/detail
      var _this = this;
      var OEMdomain = this.$OEMdomain;
      this.$ajax
        .post(this.G_uri + "/agent/detail", {
          webSite: OEMdomain,
        })
        .then(function (res) {
          if (res.data.code == 2000) {
            _this.agentId = res.data.data.agentId;
            _this.openProvinceData = res.data.data.openProvince;
          } else if (res.data.code == 1016) {
            _this.$router.push("/login");
          }
        })
        .catch(function (error) {});
    },
    //获取最低高考年份
    getYear() {
      var date = new Date();
      var year = date.getFullYear();
      var mounth = date.getMonth() + 1;   
      var day = date.getDate();
      if (mounth >= 9) {
        year += 1;
      }
      this.years = year;
      this.year = year;
    },
    getDate(){
      var _this = this;
      this.$ajax
        .post(this.G_uri + "/register/getSpecificDate")
        .then(function (res) {
          if (res.status == 200) {
            console.log(res.data.data)
            var year = Number(res.data.data.years); //赋值后台返回的年份
            var mounth = Number(res.data.data.month);
            if (mounth >= 9) {
                 year += 1;
            }
            _this.years = year;
            _this.year = year;
          }
        })
        .catch(function (error) {});

    }
  },
  created: function () {
    this.getDate();
    // this.getYear();
    this.getCityData();
    this.getProvance();
  },
  mounted() {
    console.log($(".user"));
    $(".user").css("background", 'url("/imgs/user/zhucebg.png")');
  },
};
</script>
<style type="text/css" lang='less' scoped>
.mark {
  //position: absolute;
  //width: 100%;
  //left: 0px;
  //top: 0px;
  //bottom: 0px;
  //overflow-y: scroll;
  //right: 0px;
  //z-index: 100000000;
  //background: url("/imgs/user/zhucebg.png")  no-repeat;
  //background-size: cover;
}
.perfectInformation {
  * {
    box-sizing: border-box;
  }
  .title {
    line-height: 28px;
    color: #333333;
    font-size: 16px;
    text-align: center;
    margin: 60px auto 40px;
    font-weight: bold;
  }
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -500px;
  margin-top: -277px;
  width: 1000px;
  height: 574px;
  z-index: 10000;
  .right_content {
    float: right;
    width: 600px;
    height: 574px;
    .warning {
      height: 30px;
      font-size: 12px;
      color: red;
      line-height: 30px;
      text-align: center;
    }
    .no1 {
      float: left;
      width: 70px;
      height: 26px;
      line-height: 26px;
      font-size: 14px;
      color: #7c7c7c;
      text-align: right;
      margin-left: 5px;
    }
    .linkage {
      // padding-top: 30px;
      position: relative;
      margin-bottom: 24px;
      height: 26px;
      .el {
        float: left;
      }

      .no2 {
        float: left;
        height: 26px;
        line-height: 26px;
        font-size: 14px;
        color: #333;
        margin-right: 10px;
        border-left: 0px solid #000;
        padding: 0px 4px;
      }
      .childSpan {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
      ul {
        li {
          width: 120px !important;
          padding: 0px !important;
        }
      }
    }
    .xuexiao {
      position: relative;
      margin-bottom: 24px;
      input {
        width: 290px;
        padding-left: 10px;
        height: 26px;
        border: none;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        color: #333;
        font-size: 14px;
      }
      input::-webkit-input-placeholder {
        color: rgba(124, 124, 124, 0.46);
      }
    }
    .year {
      position: relative;
      margin-bottom: 24px;
      .no2 {
        color: red;
      }
    }
    .ownname {
      height: 26px;
      margin-bottom: 35px;
      input {
        width: 290px;
        padding-left: 10px;
        height: 26px;
        border: none;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        color: #333;
        font-size: 14px;
      }
      input::-webkit-input-placeholder {
        color: rgba(124, 124, 124, 0.46);
      }
    }
    .sex {
      margin-bottom: 10px;
      .no2 {
        color: red;
      }
    }
    .goHome {
      font-size: 16px;
      width: 166px;
      height: 46px;
      border-radius: 28px;
      color: #fff;
      text-align: center;
      line-height: 46px;
      background-color: #3492f9;
      margin: 0 auto;
      border-radius: 22px;
      cursor: pointer;
      box-shadow: 0px 3px 5px #246cbb;
      &:active {
        background-color: #246cbb;
      }
    }
    .bottom {
      font-size: 12px;
      line-height: 50px;
      text-align: center;
      color: red;
    }
  }
  .userTab {
    margin: 16px 0 30px;
    overflow: hidden;
    .item {
      width: 50px;
      height: 28px;
      float: left;
      margin-right: 20px;
      background-size: 100% 100%;
      cursor: pointer;
      span {
        display: block;
        text-align: center;
        margin-left: 20px;
        line-height: 28px;
      }
    }
  }
  .left_banner {
    width: 400px;
    height: 100%;
    background: url("/imgs/user/leftbg.png") center center no-repeat;
    float: left;
  }
}
.centerpng {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 1000px;
  height: 574px;
  margin-left: -500px;
  margin-top: -277px;
  z-index: 1000;
  max-width: inherit;
}
</style>
<style type="text/css" lang='less'>
.classNumber {
  width: 120px !important;
  box-sizing: border-box;
  input {
    border: 1px solid #d9d9d9 !important;
  }
}
.zheceng {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
}
.perfectInformation .linkage .suozaidi1 .el-input__inner {
  width: 103px;
  height: 26px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}
.perfectInformation .linkage .suozaidi2 .el-input__inner {
  width: 103px;
  height: 26px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}
.perfectInformation .linkage .suozaidi3 .el-input__inner {
  width: 103px;
  height: 26px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}
.perfectInformation .year .year1 .el-input__inner {
  width: 103px;
  height: 26px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}
.perfectInformation {
  .el-input__icon {
    line-height: 24px;
  }
}
.perfectInformation .sex {
  .el-radio-group .is-checked {
    background-color: #fff;
    border: none !important;
  }
  .el-radio-group .el-radio {
    // margin-right: 35px;
    margin-bottom: 0px;
    height: 26px;
    line-height: 26px;
    // display: flex;
    // vertical-align: middle;
    // align-items: center;
    .el-radio__label {
      display: inline-block;
      padding: 0px 40px;
      line-height: 42px;
      height: 42px;
      background: url(/imgs/user/men.png) no-repeat 13px center;
    }
    .el-radio__input {
      padding-top: 0px;
      line-height: 42px;
      .el-radio__inner {
        margin-top: 15px;
      }
    }
  }
  .el-radio-group .el-radio .el-radio__input {
    display: block;
    float: left;
    padding-top: 0px;
  }
  .is-checked .el-radio__label {
    color: #333 !important;
  }

  .women {
    .el-radio__label {
      background: url(/imgs/user/women.png) no-repeat 13px center !important;
    }
  }
}
</style>
<style type="text/css">
.el-popper {
  z-index: 10000000000000 !important;
}
</style>


